module.exports = __webpack_public_path__ + "static/media/no-photo.bf8c96c2.png";